
export interface PackageType {
  id: number,
  name: string,
  code: string
}
